<template>
  <div>
    <list row-key="id" ref="list" unit="采购统计" :query-params="params" item-name="Items" :layout="layout" size="small"
      show-summary :summary-method="summaryMethod" :center-title="centerTitle" :search-title="searchTitle"
      :show-query="showQuery" :get-data-func="getDataFunc" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="toPrint">打印</el-button>
      </template>
      <template slot="query">
        <el-form-item label="供应商">
          <el-input v-model="FullName" class="long_inp" placeholder="请选择" @focus="openUnitPick" readonly />
        </el-form-item>
        <el-form-item label="原材料编码">
          <el-input v-model="ycl" class="long_inp" placeholder="请选择" @focus="openProductPick(1)" readonly />
        </el-form-item>
        <br>
        <el-form-item label="配件编码">
          <el-input v-model="pj" class="long_inp" placeholder="请选择" @focus="openProductPick(3)" readonly />
        </el-form-item>
        <el-form-item label="入库日期" style="margin-right: 219px;">
          <el-date-picker class="range-picker" v-model="dateRange" type="daterange" range-separator="~" style="width: 180px!important"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChange"
            clearable></el-date-picker>
        </el-form-item>
        <br>
        <el-form-item label="统计类型">
          <el-radio-group v-model="params.GroupType">
            <el-radio :label="0">原材料采购入库明细表</el-radio>
            <el-radio :label="1">原材料采购入库统计表</el-radio>
            <el-radio :label="2">配件采购入库明细表</el-radio>
            <el-radio :label="3">配件采购入库统计表</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template slot="table">
        <template v-if="NGT==0 || NGT==2">
          <el-table-column prop="PuDocNo" label="采购单号" />
          <el-table-column label="采购日期">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.PuDocDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PuEmpName" label="采购员工" />
          <el-table-column prop="InDocNo" label="入库单号" />
          <el-table-column label="入库日期">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.InDocDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="UnitName" label="单位" />
          <el-table-column prop="BasePrice" label="单价" />
        </template>
        <template v-else-if="NGT==1">
          <el-table-column prop="" label="原材料代码" />
          <el-table-column prop="" label="原材料名称" />
          <el-table-column prop="" label="颜色" />
          <el-table-column prop="UnitName" label="单位" />
        </template>
        <template v-else-if="NGT==3">
          <el-table-column prop="" label="配件代码" />
          <el-table-column prop="" label="配件名称" />
          <el-table-column prop="UnitName" label="单位" />
        </template>
        <el-table-column prop="PuQuantity" label="采购数量" />
        <el-table-column prop="PuAmount" label="采购金额" />
        <el-table-column prop="InQuantity" label="入库数量" />
        <el-table-column prop="InAmount" label="入库金额" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <multi-pick-dialog ref="unitMultiPick" in-dialog @select-multiple="setUnit" title="供应商列表" key-id="TradeUnitId"
      key-name="供应商名称" key-value="FullName" :func="unitApi.list" :params="{ TradeUnitTypes: [1, 2] }" second-name="供应商编号"
      second-value="TradeUnitNo" :default-value="unitArr" />
    <multi-pick-dialog ref="productyclMultiPick" in-dialog @select-multiple="setProductycl" title="原材料信息"
      key-id="ProductId" key-name="原材料编码" key-value="ProductNo" :func="proApi.list" :params="{}" second-name="原材料名称"
      second-value="ProductName" :default-value="yclArr" />
    <multi-pick-dialog ref="productpjMultiPick" in-dialog @select-multiple="setProductpj" title="配件信息"
      key-id="ProductId" key-name="配件编码" key-value="ProductNo" :func="proApi.list" :params="{}" second-name="配件名称"
      second-value="ProductName" :default-value="pjArr" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list, multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局，
  data() {
    return {
      api: require("@/api/statistics/rep").default,
      unitApi: require('@/api/ba/tradeUnit').default,
      proApi: require('@/api/ba/product').default,
      params: {
        ListTradeUnitName: [],
        ListMaterialNo: [],
        ListAcceNo: [],
        InDateBegin: "",
        InDateEnd: "",
        GroupType: 0,
      },
      FullName: "",
      unitArr: [],
      //---
      ycl: "",
      yclArr: [],
      //---
      pj: "",
      pjArr: [],
      //---
      dateRange: [],
      NGT: 0,
      centerTitle: "",
      searchTitle: "",
    };
  },
  computed: {
    layout() {
      return [
        { name: "供应商编码", key: "TradeUnitNo", span: 6 },
        { name: "供应商名称", key: "TradeUnitName", span: 18 },
      ];
    }
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.NGT = params.GroupType;
        switch (params.GroupType) {
          case 0:
            this.centerTitle = "原材料采购统计表";
            this.searchTitle = "原材料采购入库明细表";
            break;
          case 1:
            this.centerTitle = "原材料采购统计汇总表";
            this.searchTitle = "原材料采购入库统计表";
            break;
          case 2:
            this.centerTitle = "配件采购统计表";
            this.searchTitle = "配件采购入库明细表";
            break;
          case 3:
            this.centerTitle = "配件采购统计汇总表";
            this.searchTitle = "配件采购入库统计表";
            break;
        }
        // let Data = [];
        // Data = [
        //   { TradeUnitName: "张三", TradeUnitNo: "001", OrderNo: "O001", items: [{ BatchNo: "B001", ColorName: "红色", Quantity: 10 }, { BatchNo: "B002", ColorName: "绿色", Quantity: 20 }] },
        //   { TradeUnitName: "李四", TradeUnitNo: "002", OrderNo: "O002", items: [{ ColorName: "白色" }] },
        // ];
        // resolve({ Data });
        this.api.repPurchasSum(this.$commonJs.obj.removeNullKey(params)).then((res) => {
          resolve(res);
        });
      });
    },
    openUnitPick() {
      this.$refs.unitMultiPick.open();
    },
    setUnit(e, n) {
      this.unitArr = e;
      this.FullName = n;
      this.params.ListTradeUnitName = n ? n.split(",") : [];
    },
    setProductycl(e, n) {
      this.yclArr = e;
      this.ycl = n;
      this.params.ListMaterialNo = n ? n.split(",") : [];
    },
    setProductpj(e, n) {
      this.pjArr = e;
      this.pj = n;
      this.params.ListAcceNo = n ? n.split(",") : [];
    },
    onChange(e) {
      this.params.InDateBegin = e ? e[0] : "";
      this.params.InDateEnd = e ? e[1] : "";
    },
    reset() {
      let today = this.$commonJs.getToday();
      this.dateRange = [today.substr(0, 8) + "01", today];
      this.params.InDateBegin = today.substr(0, 8) + "01";
      this.params.InDateEnd = today;
      this.unitArr = [];
      this.FullName = "";
      this.yclArr = [];
      this.ycl = "";
      this.pjArr = [];
      this.pj = "";
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        } else if (((this.NGT == 0 || this.NGT == 2) && index > 6) || (this.NGT == 1 && index > 3) || (this.NGT == 3 && index > 2)) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index]);
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    toPrint() {
      let path = "/purchaseStatisticPrint?type=" + this.$refs.list.tempQueryParams.GroupType;
      sessionStorage.setItem(path, JSON.stringify(this.$refs.list.data));
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>